/** Mirrors the ToolId enum from common/enums.proto: there is no endpoint listing them */
export const TOOL_IDS = ['MINI_APP_IMAGE', 'MINI_APP_VIDEO', 'MINI_APP_IMAGE_EDIT'];

const toolNames: { [key: string]: string } = {
  MINI_APP_IMAGE: 'Image',
  MINI_APP_VIDEO: 'Video',
  MINI_APP_IMAGE_EDIT: 'Image edit',
};

/** The backend sends raw enum values, so an unknown tool keeps its own name */
export const formatToolIdName = (toolId: string) => {
  return toolNames[toolId] ?? toolId;
};
